import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Form,
  Input,
  Row,
} from 'antd';
import { useSelector } from 'react-redux';
import { selectUser } from 'store/auth';
import Select from 'components/Select';
import { Text, Button, Title } from 'components';
import { getNombreCompleto } from 'utils/padronesToString';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { siteKey } from 'utils/env';
import { Turnstile } from '@marsidev/react-turnstile';
import {
  generateCURPRules,
  generateEmailRules,
  generatePhoneRules,
  generateRFCRules,
} from 'utils/rules';

const rules = {
  required: [{ required: true }],
  curp: generateCURPRules({ required: false }),
  rfc: generateRFCRules({ required: false }),
  email: generateEmailRules({ required: false }),
  phone: generatePhoneRules({ required: false }),
};

const DatosSolicitante = ({ visible }) => {
  const user = useSelector(selectUser);
  const form = Form.useFormInstance();
  const cita_en_representacion = Form.useWatch('cita_en_representacion', form);

  const onChangeTercero = (_cita_en_representacion) => {
    form.setFieldsValue({
      cita_en_representacion: _cita_en_representacion,
      nombre_representa: _cita_en_representacion ? '' : null,
      apellido_paterno_representa: _cita_en_representacion ? '' : null,
      apellido_materno_representa: _cita_en_representacion ? '' : null,
    });
  };

  return (
    <Col span={visible ? 24 : 0}>
      <Row gutter={10} style={{ height: '100%', paddingBottom: 20 }}>
        {!cita_en_representacion && (
          <Col span={24}>
            <Text strong>
              Cita será agendada a nombre de:
              {' '}
              <Text strong>{getNombreCompleto(user)}</Text>
              <Col span={24} />
              <Button type="link" style={{ paddingInline: 0 }} onClick={() => onChangeTercero(true)}>
                <Text $accent strong>Solicitar para otra persona</Text>
                <ArrowRightOutlined />
              </Button>
            </Text>
          </Col>
        )}
        {cita_en_representacion && (
          <>
            <Title level={4}>
              <Button type="link" onClick={() => onChangeTercero(false)}>
                <ArrowLeftOutlined />
              </Button>
              Ingresa los datos de la persona
            </Title>
            <Col span={24} />
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="nombre_representa" label="Nombre" rules={rules.required}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="apellido_paterno_representa" label="Apellido Paterno" rules={rules.required}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="apellido_materno_representa" label="Apellido Materno">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="curp_representa" label="CURP" rules={rules.curp}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="rfc_representa" label="RFC" rules={rules.rfc}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="telefono_representa" label="Teléfono" rules={rules.phone}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item name="correo_representa" label="Correo electrónico" rules={rules.email}>
                <Input />
              </Form.Item>
            </Col>
          </>
        )}
        <Form.Item name="cf_turnstile_token" rules={[{ required: true }]} hidden>
          <Input />
        </Form.Item>
        {visible && (
          <Form.Item noStyle>
            <Turnstile
              siteKey={siteKey}
              onSuccess={(cf_turnstile_token) => form.setFieldsValue({ cf_turnstile_token })}
              onError={() => form.setFieldsValue({ cf_turnstile_token: null })}
              onExpire={() => form.setFieldsValue({ cf_turnstile_token: null })}
            />
          </Form.Item>
        )}
      </Row>
      <Form.Item name="cita_en_representacion" hidden>
        <Select trueFalse />
      </Form.Item>
    </Col>
  );
};

DatosSolicitante.propTypes = {
  visible: PropTypes.bool,
};

DatosSolicitante.defaultProps = {
  visible: false,
};

export default DatosSolicitante;
